<template>
  <!-- 考试中心 -->
  <div class="template-list main-container">
    <div class="main-panel">
      <div class="search-box gauge_20">
        <div class="input-item">
          <span class="label">考试名称</span>
          <Input v-model="search.name" clearable placeholder="请输入" />
        </div>
        <div class="input-item">
          <span class="label">考试分类</span>
          <Select v-model="search.testColumnId" placeholder="请选择" filterable clearable>
            <Option :value="item.id" v-for="(item, index) in menuList" :key="index">
              {{ item.name }}
            </Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否上架</span>
          <Select v-model="search.isUse" placeholder="请选择" filterable clearable>
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax(1)">查询</Button>
          <Button type="warning" @click="openTemplateEdit({})" v-if="$units.pointAction('content_5_2_1')">新建</Button>
        </div>
      </div>
      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" border>
          <template slot-scope="{ row }" slot="isLong">
            <span v-if="row.beginDate && row.endDate">{{ row.beginDate | filterTime('YYYY-MM-DD') }} - {{ row.endDate | filterTime('YYYY-MM-DD') }}</span>
            <span v-else>长期有效</span>
          </template>
          <template slot-scope="{ row }" slot="isUse">
            <i-switch size="large" true-value="1" false-value="0" v-model="row.isUse" @on-change="switchChange(row)" :disabled="$units.pointAction('content_5_2_2')?false:true">
              <span slot="open">上架</span>
              <span slot="close">下架</span>
            </i-switch>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="openTemplateEdit(row)" v-if="$units.pointAction('content_5_2_2')">编辑</span>
              <span class="table-btn" @click="openQuestion(row)" v-if="$units.pointAction('content_5_2_3')">查看考题</span>
              <span class="table-btn" @click="openEditCourse(row)" v-if="$units.pointAction('content_5_2_4')">关联课程</span>
              <span class="table-btn" @click="openDetail(row)" v-if="$units.pointAction('content_5_2_5')">查看完成详情</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
    </div>
    <editTest ref="editTest" @reload="getList" @refresh="getMenuList" :menuList="menuList"></editTest>
    <editQuestion ref="editQuestion"></editQuestion>
    <editCourse ref="editCourse"></editCourse>
    <detail ref="detail"></detail>
    <!-- 模板使用详情 -->
  </div>
</template>

<script>
import config from './templateList.config';
import editTest from './components/editTest';
import editCourse from './components/editCourse';
import editQuestion from './components/editQuestion';
import detail from './components/detail';
export default {
  components: {
    editTest,
    editQuestion,
    editCourse,
    detail
  },

  data() {
    return config;
  },

  created() {
    if (
        !this.$units.pointAction('content_5_2_2') &&
        !this.$units.pointAction('content_5_2_3') &&
        !this.$units.pointAction('content_5_2_4') &&
        !this.$units.pointAction('content_5_2_5')
    ) {
        this.columns.splice(this.columns.length - 1, 1);
    }
    this.searchAjax();
    this.getMenuList();
  },

  methods: {
    getMenuList() {
      this.$http({
        url: '/buz/testColumn/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.menuList = res.data;
      });
    },
    async switchChange(item) {
      let res = await this.$http({
        url: '/buz/testCenter/checkNums',
        type: 'GET',
        data: {
          id: item.id
        }
      });
      let msg = '';
      if (!res.data.courseNum || !res.data.questionNum) {
        if (!res.data.courseNum && res.data.questionNum && item.isUse == 1) msg = '暂未关联课程，上架后不可用于入职考试，请确认是否上架？';
        if (res.data.courseNum && !res.data.questionNum && item.isUse == 1) msg = '该考试未配置考题，不可上架！';
        if (!res.data.courseNum && !res.data.questionNum && item.isUse == 1) msg = '该考试未配置考题及未关联课程，不可上架！';
      }
      if (msg) {
        if (!res.data.courseNum && res.data.questionNum && item.isUse == 1) {
          this.$notice
            .inquiry(msg)
            .then(() => {
              this.updateUseStatus(item);
            })
            .catch(() => {
              item.isUse = item.isUse == '1' ? '0' : '1';
            });
        } else {
          this.$notice.alert(msg);
          item.isUse = item.isUse == '1' ? '0' : '1';
        }
      } else {
        this.updateUseStatus(item);
      }
    },
    updateUseStatus(item) {
      this.$http({
        url: `/buz/testCenter/updateUseStatus/${item.id}/${item.isUse}`,
        type: 'POST',
        data: {},
        apiPermissionCode: 'operate_3_3_5'
      })
        .then(res => {
          this.$notice.success('操作成功');
          this.getList();
        })
        .catch(() => {
          item.isUse = item.isUse == '1' ? '0' : '1';
        });
    },
    // 删除模板
    delTemplate(item) {
      this.$notice.inquiry('确定删除课程？').then(() => {
        this.$http({
          url: '/buz/courseColumn/del',
          type: 'get',
          data: {
            id: item.id
          }
        }).then(res => {
          this.$notice.success('删除课程成功');
          this.searchAjax();
        });
      });
    },
    openEditCourse(row) {
      this.$refs.editCourse.open(row || {});
    },
    openDetail(row) {
      this.$refs.detail.open(row.id || '');
    },
    // 打开模板编辑或新增弹窗
    openTemplateEdit(item) {
      this.$refs.editTest.open(item || {});
    },
    // 打开模板编辑或新增弹窗
    openQuestion(item) {
      this.$refs.editQuestion.open(item || {});
    },
    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: '/buz/testCenter/read/list',
        type: 'post',
        data: params,
        apiPermissionCode: 'operate_3_3_0'
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
/deep/.ivu-select {
  display: unset;
  overflow: unset !important;
}
</style>
